module.exports = __webpack_public_path__ + "static/banner04cherries-c60d3e542b3871b610c7f91367869c34.jpg";